import { MessageType } from '../enums/messagetype.enum';

export class ReceivedMessage {
    MessageType: MessageType;
    Title: string;
    Content: string;
    Read: boolean;
    CreateDate: Date;
}